import gql from 'graphql-tag';

const LectureVideosQuery = gql`
  query LectureVideosQuery($id: String!) {
    OnDemandLectureVideosV1 @naptime {
      get(id: $id, includes: "video") {
        elements {
          id
          videoId
        }
        linked {
          onDemandVideosV1 {
            sources
            subtitlesVtt
            subtitlesAssetTags
          }
        }
      }
    }
  }
`;

export default LectureVideosQuery;
